<template>
    <card-seplag titulo="Dados Pessoais" cor="#00acc1" v-if="dadosPessoa.dadosPessoais">

        <div class="p-col-12 avisos">
            <p>Siga os passos a seguir para concluir essa Etapa: </p>
            <ol>
                <li class="passosSeguir">
                    Atualize as informações que precisam de alteração.
                </li>
                <li class="passosSeguir">
                    Para envio da foto, será aceito pelo sistema uma foto 3X4 no formato JPEG OU PNG com tamanho até 2 MB. A foto deve ser tirada de frente com o fundo 
                    branco, que apareça apenas o rosto e os ombros. Os olhos devem estar abertos. Não usar acessório que dificulte a identificação
                    (óculos escuros, chapéu, boné, máscara) exceto por motivos religiosos. Não usar filtros de Redes Sociais.
                </li>
                <li class="passosSeguir">
                    Quando tudo estiver correto e alterado, selecione o botão “Salvar” e “Finalizar etapa” que estão no
                    final da página.
                </li>
               
            </ol>
            
        </div>
        <label style='color: red;'><span>*</span> Campos obrigatórios</label>

        <Rotulo nome="" cols='12'></Rotulo>
        <Rotulo nome="Foto" cols='12 4 2'>
            <Rotulo cols="2 2 2 ">
            </Rotulo>
            <div class="borderline">
                <img v-if="!aux" src="../../../public/assets/layout/images/fotoDefault.jpg" alt="Cropped Image"
                    class="imagemResponsiva" />
                <img v-if="aux" :src="aux" alt="Cropped Image" class="imagemResponsiva" />
            </div>
        </Rotulo>
        <Rotulo cols="12 4 4 " class="arquivoRejeitado"
            v-if="(idenDadoPessoal.dadosPessoais.arquivosDadoPessoal.length > 0 && idenDadoPessoal.dadosPessoais.arquivosDadoPessoal[0].motivoRejeicao != null)">
            <div class="p-col-12 avisos arquivoRejeitado">
                <span><strong>Foto rejeitada pela chefia imediata:</strong></span>
                <pre>{{ idenDadoPessoal.dadosPessoais.arquivosDadoPessoal[0].motivoRejeicao.descMotivoRejeicao }}</pre>
            </div>
        </Rotulo>
        <Rotulo cols="12 " />
        <Rotulo nome="Matrícula" cols='12 4'>
            <InputText type="text" disabled v-if="dadosPessoa.pessoa.pessoaGeral.servidor"
                v-model="dadosPessoa.pessoa.pessoaGeral.servidor.numrMatricula" />
            <InputText type="text" disabled v-else v-model="auxMatricula" />
        </Rotulo>
        <Rotulo nome="CPF" cols='12 4'>
            <InputText type="text" disabled v-model="dadosPessoa.pessoa.pessoaGeral.cpfFormatado" />
        </Rotulo>
        <Rotulo nome="" cols='12 4'>
        </Rotulo>
        <Rotulo nome="Nome" cols='12 8'>
            <InputText type="text" disabled v-model="dadosPessoa.dadosPessoais.nomePessoa" />
        </Rotulo>

        <Rotulo nome="Seu nome está correto?" cols="12 2">
            <div style="display:flex; flex-direction:column;    align-items: flex-start;">
                <div style="display:flex;align-items: center; justify-content: flex-start;margin:2px">

                    <RadioButton :disabled="true" inputId="sim" name="nomeCorreto" :value="true" v-model="checkNomeCorreto" />

                    <label for="sim" style="margin-left:10px"> Sim</label>
                </div>

                <div style="display:flex;align-items: center; justify-content: flex-start;margin:2px">

                    <RadioButton :disabled="true" inputId="sim" name="nomeCorreto" :value="false" v-model="checkNomeCorreto"
                         />

                    <label for="nao" style="margin-left:10px"> Não</label>
                </div>
            </div>

        </Rotulo>
        <Rotulo nome="Possui nome social?" cols="12 2">
            <div style="display:flex; flex-direction:column;    align-items: flex-start;">
                <div style="display:flex;align-items: center; justify-content: flex-start;margin:2px ">
                    <RadioButton inputId="selecionarNome1" v-model="nomeSocialEscolha" name="selecionarNome"
                        :value="true" :disabled="true" />
                    <label for="selecionarNome1" style="margin-left:10px">Sim</label>
                </div>
                <div style="display:flex;align-items: center; justify-content: flex-start;margin:2px ">
                    <RadioButton inputId="selecionarNome2" v-model="nomeSocialEscolha" name="selecionarNome" :value="false"
                         :disabled="true"/>
                    <label for="selecionarNome2" style="margin-left:10px">Não</label>
                </div>
            </div>
        </Rotulo>
        <Rotulo nome="Nome social" cols='12 8' v-if="nomeSocialEscolha"
            :requerido="dadosPessoa.dadosPessoais.nomeSocial ? true : false">
            <InputText type="text" v-model="dadosPessoa.dadosPessoais.nomeSocial"
                v-tooltip.top="'Nome social: aquele pelo qual a pessoa se reconhece, bem como é identificado por sua comunidade e em seu meio social. Decreto nº 854/2021, D.O.E 12/03/2021'"
                disabled />
        </Rotulo>
        <Rotulo nome="Número do processo" cols='12 4' v-if="nomeSocialEscolha"
            :requerido="dadosPessoa.dadosPessoais.nomeSocial ? true : false">
            <InputText type="text" v-model="dadosPessoa.dadosPessoais.numrProcesso"
                :v-required="dadosPessoa.dadosPessoais.nomeSocial" />
        </Rotulo>
        <Rotulo nome="Sexo" cols='12 3'>
            <div style="display:flex; flex-direction:column;    align-items: flex-start;">
                <div style="display:flex;align-items: center; justify-content: flex-start;margin:2px">

                    <RadioButton inputId="M" name="sexo" :value="sexo[0]" v-model="dadosPessoa.dadosPessoais.sexo"
                        :disabled="true"  />

                    <label for="sim" style="margin-left:10px"> Masculino</label>
                </div>

                <div style="display:flex;align-items: center; justify-content: flex-start;margin:2px">

                    <RadioButton inputId="F" name="sexo" :value="sexo[1]" v-model="dadosPessoa.dadosPessoais.sexo"
                        :disabled="true"  />

                    <label for="nao" style="margin-left:10px">Feminino</label>
                </div>
            </div>
        </Rotulo>

        <Rotulo nome="Estado civil" cols='12 3'>
            <Dropdown v-model="dadosPessoa.dadosPessoais.estadoCivil" :options="estadocivil" optionLabel="descEstadoCivil"
                placeholder="Selecione..." v-required 
                disabled />
        </Rotulo>

        <Rotulo nome="Grupo sanguíneo" cols='12 3'>
            <Dropdown v-model="dadosPessoa.dadosPessoais.grupoSanguineo" :options="grupoSanguineo"
                optionLabel="descGrupoSanguineo" placeholder="Selecione..."
                disabled />
        </Rotulo>
        <Rotulo nome="Data de nascimento" cols='12 3'>
            <InputMask mask="99/99/9999" placeholder="dd/mm/aaaa" disabled
                v-model="dadosPessoa.dadosPessoais.dataNascimento" v-required  />
        </Rotulo>
        <Rotulo nome="Data de nascimento correta?" cols='12 3'>

            <div style="display:flex; flex-direction:column;    align-items: flex-start;">
                <div style="display:flex;align-items: center; justify-content: flex-start;margin:2px">

                    <RadioButton inputId="sim" name="DataNascCorreta" :value="true" v-model="checkDataNascCorreta"
                        :disabled="true"/>

                    <label for="sim" style="margin-left:10px"> Sim</label>
                </div>

                <div style="display:flex;align-items: center; justify-content: flex-start;margin:2px">

                    <RadioButton :disabled="true" inputId="nao" name="DataNascCorreta" :value="false" v-model="checkDataNascCorreta"
                         />

                    <label for="nao" style="margin-left:10px"> Não</label>
                </div>
            </div>

        </Rotulo>
        <Rotulo nome="País de nascimento" cols='12 3'>
            <Dropdown v-model="dadosPessoa.dadosPessoais.pais" :filter="true" :options="paises" optionLabel="nomePais"
                placeholder="Selecione..."  v-required
                disabled />
        </Rotulo>
        <Rotulo nome="UF" cols='12 3'>
            <Dropdown v-model="dadosPessoa.dadosPessoais.uf" :options="ufs" optionLabel="siglUf" placeholder="Selecione..."
                v-required disabled />
        </Rotulo>
        <Rotulo nome="Cidade natal" cols='12 3'>
            <Dropdown v-model="dadosPessoa.dadosPessoais.cidade" :filter="true" :options="cidades" optionLabel="nomeCidade"
                placeholder="Selecione..." v-required
                disabled/>
        </Rotulo>
        <Rotulo nome="Raça ou cor" cols='12 3'>
            <Dropdown v-model="dadosPessoa.dadosPessoais.tipoRacaCor" :options="cor" optionLabel="descTipoRacaCor"
                placeholder="Selecione..." v-required
                disabled />
        </Rotulo>
        <Rotulo nome="Escolaridade atual" cols='12 3'>
            <Dropdown v-model="dadosPessoa.dadosPessoais.escolaridade" :options="escolaridade"
                optionLabel="nomeEscolaridade" placeholder="Selecione..." v-required
                disabled />
        </Rotulo>
        <Rotulo nome="Nacionalidade" cols='12 3'>
            <Dropdown v-model="dadosPessoa.dadosPessoais.nacionalidade" :options="nacionalidade"
                optionLabel="descNacionalidade" placeholder="Selecione..." v-required disabled
                 />
        </Rotulo>
        <Rotulo nome="Data de chegada no Brasil" cols='12 3'
            v-if="dadosPessoa.dadosPessoais.nacionalidade != null && dadosPessoa.dadosPessoais.nacionalidade.descNacionalidade != 'BRASILEIRA' && dadosPessoa.dadosPessoais.nacionalidade.descNacionalidade != 'BRASILEIRA/INDIO'">
            <InputMask mask="99/99/9999" placeholder="dd/mm/aaaa" v-model="dadosPessoa.dadosPessoais.dataEntradaPais" disabled />
        </Rotulo>
        <Rotulo nome="Casado(a) com brasileira(o)?" cols='12 3'
            v-if="dadosPessoa.dadosPessoais.nacionalidade != null && dadosPessoa.dadosPessoais.nacionalidade.descNacionalidade != 'BRASILEIRA' && dadosPessoa.dadosPessoais.nacionalidade.descNacionalidade != 'BRASILEIRA/INDIO'">
            <div class="p-grid">
                <div style="display:flex;align-items: center; justify-content: flex-start;margin:10px">

                    <RadioButton inputId="simCasadoBrasileiro" name="simCasadoBrasileiro" :value="'S'"
                        v-model="dadosPessoa.dadosPessoais.flagCasadoBrasileiro" 
                        :disabled="true" />

                    <label for="simCasadoBrasileiro" style="margin-left:10px"> Sim</label>
                </div>

                <div style="display:flex;align-items: center; justify-content: flex-start;margin:10px">

                    <RadioButton inputId="naoCasadoBrasileiro" name="naoCasadoBrasileiro" :value="'N'"
                        v-model="dadosPessoa.dadosPessoais.flagCasadoBrasileiro" 
                        :disabled="true" />

                    <label for="naoCasadoBrasileiro" style="margin-left:10px"> Não</label>
                </div>
            </div>
        </Rotulo>
        <Rotulo nome="" cols='12'>
            <card-seplag titulo="Deficiência" class="p-col-12">
                <Rotulo nome="Possui algum tipo de deficiência?" cols='12'>
                    <div class="p-grid">
                        <div style="display:flex;align-items: center; justify-content: flex-start;margin:10px">

                            <RadioButton inputId="simPossuoDeficiencia" name="simPossuoDeficiência" :value="true"
                                v-model="checkPossuiDeficiencia" 
                                :disabled="true"  />

                            <label for="simPossuoDeficiencia" style="margin-left:10px"> Sim</label>
                        </div>

                        <div style="display:flex;align-items: center; justify-content: flex-start;margin:10px">

                            <RadioButton inputId="naoPossuoDeficiencia" name="naoPossuoDeficiencia" :value="false"
                                v-model="checkPossuiDeficiencia"
                                :disabled="true"  />

                            <label for="naoPossuoDeficiencia" style="margin-left:10px"> Não</label>
                        </div>
                    </div>
                    
                </Rotulo>
                <Rotulo cols='12'>
                </Rotulo>
                <Rotulo nome="Qual?" cols='12' v-if="deficiencia.length > 0 && checkPossuiDeficiencia == true">
                    <br>
                    <div class="p-grid p-fluid checkBox">
                        <div class="p-col-6 p-md-2 p-field-checkbox " v-for="tipodeficiencia of deficiencia"
                            :key="tipodeficiencia.idenTipoDeficiencia">
                            <Checkbox :id="'deficiencia' + tipodeficiencia.idenTipoDeficiencia"
                                :inputId="tipodeficiencia.idenTipoDeficiencia" :name="tipodeficiencia.descTipoDeficiencia"
                                :value="tipodeficiencia" v-model="dadosPessoa.dadosPessoais.dadosPessoalTpDef"
                                disabled />
                            <label class="p-chkbox-label" :for="'deficiencia' + tipodeficiencia.idenTipoDeficiencia">{{
                                tipodeficiencia.descTipoDeficiencia
                            }}</label>
                        </div>
                    </div>
                </Rotulo>
            </card-seplag>
        </Rotulo>

        <Rotulo nome="" cols='12'>
            <card-seplag titulo="Parentalidade" class="" cor="#00acc1">
                <Panel header="Mãe" class="p-col-12 ">
                    <div class="p-grid">
                        <Rotulo nome="CPF" cols='12 3'>
                            <InputMask type="text" mask="999.999.999-99" v-model="dadosPessoa.pessoa.numrCpfMae" disabled />
                        </Rotulo>
                        <Rotulo nome="Nome" cols='12 9'>
                            <InputText type="text" v-model="dadosPessoa.pessoa.nomeMae"
                                disabled />
                        </Rotulo>
                    </div>
                </Panel>
                <Rotulo>
                </Rotulo>
                <Panel header="Pai" class="p-col-12 ">
                    <div class="p-grid">
                        <Rotulo nome="CPF" cols='12 3'>
                            <InputMask type="text" mask="999.999.999-99" v-model="dadosPessoa.pessoa.numrCpfPai" disabled />
                        </Rotulo>
                        <Rotulo nome="Nome" cols='12 9'>
                            <InputText type="text" v-model="dadosPessoa.pessoa.nomePai"
                                disabled />
                        </Rotulo>
                    </div>
                </Panel>
                <Rotulo>
                </Rotulo>
                <Panel header="Cônjuge" class="p-col-12 "
                    v-if="dadosPessoa.dadosPessoais.estadoCivil != null && (dadosPessoa.dadosPessoais.estadoCivil.descEstadoCivil == 'CASADO(A)' || dadosPessoa.dadosPessoais.estadoCivil.descEstadoCivil == 'COMPANHEIRO(A)')">
                    <div class="p-grid">
                        <Rotulo nome="CPF" cols='12 3'>
                            <InputMask name="CPF"  mask="999.999.999-99"
                                v-model="registroConjuge.parentalidade.pessoaParentalidade.numrCpf" masked="false"
                                 disabled />
                        </Rotulo>
                        <Rotulo nome="Nome" cols='12 9'>
                            <InputText type="text" v-model="registroConjuge.parentalidade.pessoaParentalidade.nomePessoa"
                                :disabled="registroConjuge.parentalidade.pessoaParentalidade.flagServidor == 'S' || registroConjuge.parentalidade.pessoaParentalidade.numrCpf == '' || !checkNomeCorreto || !checkDataNascCorreta"
                                />
                        </Rotulo>

                        <Rotulo nome="Data de nascimento" cols="12 3">
                            <InputMask name="dataNascimento"
                                v-model="registroConjuge.parentalidade.pessoaParentalidade.dataNascimento" mask="99/99/9999"
                                masked="false"
                                :disabled="registroConjuge.parentalidade.pessoaParentalidade.flagServidor == 'S' || registroConjuge.parentalidade.pessoaParentalidade.numrCpf == '' || !checkNomeCorreto || !checkDataNascCorreta"
                                />
                        </Rotulo>
                        <Rotulo nome="Nome da mãe" cols='12 9'>
                            <InputText type="text" v-model="registroConjuge.parentalidade.pessoaParentalidade.nomeMae"
                                :disabled="registroConjuge.parentalidade.pessoaParentalidade.flagServidor == 'S' || registroConjuge.parentalidade.pessoaParentalidade.numrCpf == '' || !checkNomeCorreto || !checkDataNascCorreta"
                                  />
                        </Rotulo>
                    </div>
                </Panel>
            </card-seplag>
        </Rotulo>

        <div class="p-col-12">
            <div class="p-grid">
                <div class="p-col-12 p-md-2 p-md-offset-4">
                    <Button label="Finalizar Etapa"  icon="pi pi-check" class="p-button-success" disabled/>
                </div>
                <div class="p-col-12 p-md-2">
                    <Button label="Próximo" @click="nextPage()" icon="pi pi-angle-right" iconPos="right"
                        :disabled="!etapaDadosPessoais || etapaDadosPessoais && etapaDadosPessoais.statCicloPessoaFase != 'CONCLUIDO'" />
                </div>
            </div>
        </div>
       
    </card-seplag>
</template>

<script>
import CardSeplag from '@/template/CardSeplag.vue'
import Rotulo from '@/template/RotuloSeplag.vue'
import { simNao, sexo } from '@/config/global'
import { baseApiUrl } from '@/config/global'
import 'cropperjs/dist/cropper.css';
import axios from 'axios'
import { printToast } from '../../config/global';



const getDefaultState = () => {
    return {
        idenDadoPessoalParental: '',
        dadoPessoal: '',
        parentalidade: {
            idenParentalidade: '',
            pessoa: '',
            pessoaParentalidade: {
                idenPessoa: '',
                nomePessoa: '',
                dataNascimento: '',
                nomeMae: '',
                numrCpf: '',
                flagServidor: '',
            },
            tipoParentalidade: '',
            statParentalidade: ''
        },
        statDadoPessoalParental: ''
    }
}

export default {
    name: "dadosPessoaisView",
    components: { CardSeplag, Rotulo, },
    data: function () {
        return {
            exibirTelaParentalidade: false,
            vinculos: this.$store.getters.getCicloPessoa,
            retornoValidacao: '',
            modoEdicao: 'alterar',
            dadosPessoa: [],
            simNao: simNao,
            checkNomeCorreto: true,
            checkDataNascCorreta: true,
            checkPossuiDeficiencia: false,
            estadocivil: [],
            sexo: sexo,
            grupoSanguineo: [],
            deficiencia: [],
            paises: [],
            cidades: [],
            ufs: [],
            nacionalidade: [],
            cor: [],
            escolaridade: [],
            tiposParentalidade: [
                { idenTipoParentalidade: 5, descTipoParentalidade: "CONJUGE" },
                { idenTipoParentalidade: 13, descTipoParentalidade: "PAI/MAE" }
            ],
            tiposParentalidadeIncluir: [
                { idenTipoParentalidade: 5, descTipoParentalidade: "Incluir Cônjuge" },
                { idenTipoParentalidade: 13, descTipoParentalidade: "Incluir Mãe" },
                { idenTipoParentalidade: 15, descTipoParentalidade: "Incluir Pai" }
            ],
            parentalidades: [],
            registroConjuge: getDefaultState(),
            etapaDadosPessoais: null,
            auxMatricula: "Não Possui - Empregado Publico",
            isSalvo: false,
            preview: null,
            image: null,
            imgSrc: "",
            cropImg: "",
            imgDef: "",
            modalFoto: false,
            nomeSocialEscolha: false,
            numrProcesso: null,
            teste: null,
            inicioBaseApiUrl: baseApiUrl,
            file: null,
            file2: null,
            teste2: null,
            idenDadoPessoal: this.$store.getters.getDadosPessoa,
            documentosCadastrados: [],
            teste3: [],
            documento: null,
            mime_type: "image/jpeg",
            selectedFile: '',
            files: '',
            imagemFoto: null,
            tamanhoFoto: null,
            aux: null,
            auxidFoto: null,
            sad:''

        }
    },
    methods: {
        converteMaiuscula(atributo) {
            if (atributo == "nomeSocial") {
                this.dadosPessoa.dadosPessoais.nomeSocial = this.especialCharMask(this.dadosPessoa.dadosPessoais.nomeSocial).toUpperCase()
            } else if (atributo == "nomeMae") {
                this.dadosPessoa.pessoa.nomeMae = this.especialCharMask(this.dadosPessoa.pessoa.nomeMae).toUpperCase()
            } else if (atributo == "nomePai") {
                this.dadosPessoa.pessoa.nomePai = this.especialCharMask(this.dadosPessoa.pessoa.nomePai).toUpperCase()
            } else if (atributo == "nomeConjuge") {
                this.registroConjuge.parentalidade.pessoaParentalidade.nomePessoa = this.especialCharMask(this.registroConjuge.parentalidade.pessoaParentalidade.nomePessoa).toUpperCase()
            } else if (atributo == "nomeMaeConjuge") {
                this.registroConjuge.parentalidade.pessoaParentalidade.nomeMae = this.especialCharMask(this.registroConjuge.parentalidade.pessoaParentalidade.nomeMae).toUpperCase()
            }
        },
        especialCharMask(str) {

            str = str.replace(/[^a-zA-Z\s]/g, '')
            //str = str.replace(/[0-9]/g,'')

            return str;
        },
        mascaraCpf(valor) {
            return valor.replace(/(\d{3})(\d{3})(\d{3})(\d{2})/g, "$1.$2.$3-$4");
        },
        salvar() {            
            if (this.nomeSocialEscolha) {
                if (this.dadosPessoa.dadosPessoais.nomeSocial && this.dadosPessoa.dadosPessoais.numrProcesso.length > 0) {
                    
                    this.dadosPessoa.dadosPessoais.flagNomeCorreto = this.checkNomeCorreto ? "S" : "N"
                    this.dadosPessoa.dadosPessoais.flagDataNascCorreta = this.checkDataNascCorreta ? "S" : "N"
                    this.dadosPessoa.dadosPessoais.flagDeficiencia = this.checkPossuiDeficiencia ? "S" : "N"
                    this.dadosPessoa.dadosPessoais.flagNomeSocial = this.nomeSocialEscolha ? "S" : "N"
                    this.dadosPessoa.dadosPessoais.flagSexo = this.dadosPessoa.dadosPessoais.sexo.code == "F" ? "F" : "M"
                    if (this.dadosPessoa.dadosPessoais.nacionalidade != null && this.dadosPessoa.dadosPessoais.nacionalidade.descNacionalidade != 'BRASILEIRA' && this.dadosPessoa.dadosPessoais.nacionalidade.descNacionalidade != 'BRASILEIRA/INDIO') {
                        this.dadosPessoa.dadosPessoais.flagCasadoBrasileiro = this.dadosPessoa.dadosPessoais.flagCasadoBrasileiro
                    }
                    if (this.dadosPessoa.dadosPessoais.flagDeficiencia == "N") {
                        this.dadosPessoa.dadosPessoais.dadosPessoalTpDef = []
                    }

                   //if ((this.dadosPessoa.pessoa.nomePai != "" && this.dadosPessoa.pessoa.numrCpfPai != "") || (this.dadosPessoa.pessoa.nomeMae != "" && this.dadosPessoa.pessoa.numrCpfMae != "")) {
                        // this.atualizarDadosPaiMae()
                   // }

                    let dadosJson = {...this.dadosPessoa.pessoa}
                    if (this.dadosPessoa.pessoa.numrCpfPai != null) {
                        dadosJson.numrCpfPai = this.dadosPessoa.pessoa.numrCpfPai.split(".").join("").split("-").join("")
                    }
                    if (this.dadosPessoa.pessoa.numrCpfMae != null) {
                        dadosJson.numrCpfMae = this.dadosPessoa.pessoa.numrCpfMae.split(".").join("").split("-").join("")
                    }
                    this.$http.post(`${baseApiUrl}/pessoasRecad/atualizarDadosPaiMae/${this.dadosPessoa.pessoa.idenPessoa}`, JSON.stringify(dadosJson))
                        .then(() => {                            
                            if (this.registroConjuge.parentalidade.pessoaParentalidade.nomePessoa != '') {
                                this.salvarParentalidade()
                            }
                            this.$http.put(`${baseApiUrl}/dadopessoals/${this.dadosPessoa.dadosPessoais.idenDadoPessoal}`, JSON.stringify(this.dadosPessoa.dadosPessoais)).then(res => {
                                this.$toast.add({ severity: 'success', summary: res.data, life: 10000 })
                                this.etapaDadosPessoais = this.$store.getters.getEtapasCiclo[0]
                                this.getDadosPessoa()
                                this.isSalvo = true
                                this.$emit('changeForm', true)
                            })
                        })
                } else {
                    printToast({ severity: 'error', summary: 'Erro!', detail: 'Há campos vazios que necessitam ser preenchidos' })
                }
            } else if (!this.nomeSocialEscolha) {
                
                this.dadosPessoa.dadosPessoais.flagNomeCorreto = this.checkNomeCorreto ? "S" : "N"
                this.dadosPessoa.dadosPessoais.flagDataNascCorreta = this.checkDataNascCorreta ? "S" : "N"
                this.dadosPessoa.dadosPessoais.flagDeficiencia = this.checkPossuiDeficiencia ? "S" : "N"
                this.dadosPessoa.dadosPessoais.flagNomeSocial = this.nomeSocialEscolha ? "S" : "N"
                this.dadosPessoa.dadosPessoais.flagSexo = this.dadosPessoa.dadosPessoais.sexo.code == "F" ? "F" : "M"
                if (this.dadosPessoa.dadosPessoais.nacionalidade != null && this.dadosPessoa.dadosPessoais.nacionalidade.descNacionalidade != 'BRASILEIRA' && this.dadosPessoa.dadosPessoais.nacionalidade.descNacionalidade != 'BRASILEIRA/INDIO') {
                    this.dadosPessoa.dadosPessoais.flagCasadoBrasileiro = this.dadosPessoa.dadosPessoais.flagCasadoBrasileiro
                }
                if (this.dadosPessoa.dadosPessoais.flagDeficiencia == "N") {
                    this.dadosPessoa.dadosPessoais.dadosPessoalTpDef = []
                }

                //if ((this.dadosPessoa.pessoa.nomePai != "" && this.dadosPessoa.pessoa.numrCpfPai != "") || (this.dadosPessoa.pessoa.nomeMae != "" && this.dadosPessoa.pessoa.numrCpfMae != "")) {
                    // this.atualizarDadosPaiMae()
               // }

                let dadosJson = {...this.dadosPessoa.pessoa}
                    if (this.dadosPessoa.pessoa.numrCpfPai != null) {
                        dadosJson.numrCpfPai = this.dadosPessoa.pessoa.numrCpfPai.split(".").join("").split("-").join("")
                    }
                    if (this.dadosPessoa.pessoa.numrCpfMae != null) {
                        dadosJson.numrCpfMae = this.dadosPessoa.pessoa.numrCpfMae.split(".").join("").split("-").join("")
                    }
                    this.$http.post(`${baseApiUrl}/pessoasRecad/atualizarDadosPaiMae/${this.dadosPessoa.pessoa.idenPessoa}`, JSON.stringify(dadosJson))
                        .then(() => { 
                            
                            if (this.registroConjuge.parentalidade.pessoaParentalidade.nomePessoa != '') {
                                this.salvarParentalidade()
                            }
                            this.$http.put(`${baseApiUrl}/dadopessoals/${this.dadosPessoa.dadosPessoais.idenDadoPessoal}`, JSON.stringify(this.dadosPessoa.dadosPessoais)).then(res => {
                                this.$toast.add({ severity: 'success', summary: res.data, life: 10000 })
                                this.etapaDadosPessoais = this.$store.getters.getEtapasCiclo[0]
                                this.getDadosPessoa()
                                this.isSalvo = true
                                this.$emit('changeForm', true)
                            })
                        })
            } else {
                printToast({ severity: 'error', summary: 'Erro!', detail: 'Há campos vazios que necessitam ser preenchidos' })
            }
        },
        concluir() {
            this.salvar()
            
            this.dadosPessoa.dadosPessoais.flagNomeCorreto = this.checkNomeCorreto ? "S" : "N"
            this.dadosPessoa.dadosPessoais.flagDataNascCorreta = this.checkDataNascCorreta ? "S" : "N"
            this.dadosPessoa.dadosPessoais.flagDeficiencia = this.checkPossuiDeficiencia ? "S" : "N"
            this.dadosPessoa.dadosPessoais.flagNomeSocial = this.nomeSocialEscolha ? "S" : "N"
            this.dadosPessoa.dadosPessoais.flagSexo = this.dadosPessoa.dadosPessoais.sexo.code == "F" ? "F" : "M"
            if (this.dadosPessoa.dadosPessoais.nacionalidade != null && this.dadosPessoa.dadosPessoais.nacionalidade.descNacionalidade != 'BRASILEIRA' && this.dadosPessoa.dadosPessoais.nacionalidade.descNacionalidade != 'BRASILEIRA/INDIO') {
                this.dadosPessoa.dadosPessoais.flagCasadoBrasileiro = this.dadosPessoa.dadosPessoais.flagCasadoBrasileiro
            }

            if (this.dadosPessoa.dadosPessoais.flagDeficiencia == "N") {
                this.dadosPessoa.dadosPessoais.dadosPessoalTpDef = []
            }
            //if ((this.dadosPessoa.pessoa.nomePai != "" && this.dadosPessoa.pessoa.numrCpfPai != "") || (this.dadosPessoa.pessoa.nomeMae != "" && this.dadosPessoa.pessoa.numrCpfMae != "")) {
                // this.atualizarDadosPaiMae()
            //}
            // if (this.registroConjuge.parentalidade.pessoaParentalidade.nomePessoa != '') {
            //     this.salvarParentalidade()
            // } else 
            if (this.registroConjuge.parentalidade.pessoaParentalidade.nomePessoa == '' && this.dadosPessoa.dadosPessoais.estadoCivil && this.dadosPessoa.dadosPessoais.estadoCivil.descEstadoCivil == "CASADO(A)" || 
                this.registroConjuge.parentalidade.pessoaParentalidade.nomePessoa == '' && this.dadosPessoa.dadosPessoais.estadoCivil && this.dadosPessoa.dadosPessoais.estadoCivil.descEstadoCivil == "COMPANHEIRO(A)") {
                this.$toast.add({ severity: 'error', summary: 'Campos Obrigatórios', detail: "Para Estado Civil: CASADO(A) ou COMPANHEIRO(A) é obrigatório informar o cônjuge", life: 6000 })
                return false
            }
            this.$http.put(`${baseApiUrl}/dadopessoals/concluir/${this.dadosPessoa.dadosPessoais.idenDadoPessoal}`, JSON.stringify(this.dadosPessoa.dadosPessoais)).then(() => {
                this.$toast.add({ severity: 'success', summary: 'Ação Efetuada', detail: " Etapa Dados pessoais finalizada com Sucesso", life: 3000 })
                this.atualizarCampos()

                setTimeout(() => {
                    this.$router.push({ name: 'RECAD_DOCUMENTOS_PESSOAIS_VIEW' })
                }, 3000);
                //this.$router.push({name:'documentos'})    
            })
        },
        atualizarCampos() {
            this.$http.get(`${baseApiUrl}/ciclopessoafases/ciclopessoa/${this.$store.getters.getCicloPessoa[0].idenCicloPessoa}`).then(res => {
                let flag = this.$store.getters.getDadosPessoa.pessoa.flagServidor != 'S'
                let etapaCliclo = res.data.filter(function (etapa) {
                    if (etapa.fase.statFase != 'INATIVO' && etapa.fase.descFase != 'TERMO_ACEITE') {
                        if (etapa.fase.descFase == 'VINCULOS' && flag) {
                            return false
                        } else {
                            return true
                        }
                    } else {
                        return false
                    }
                })
                this.$store.commit("setEtapasCiclo", JSON.stringify(etapaCliclo))
                this.etapaDadosPessoais = this.$store.getters.getEtapasCiclo[0]
                this.$store.commit("setDadosPessoa", JSON.stringify(this.dadosPessoa))
                this.carregarDados()
            })
        },
        async getDadosPessoa() {
             if (this.$store.getters.getDadosPessoa) {
                this.carregarDados()             
             }else{
                await this.$http.get(`${baseApiUrl}/ciclopessoas/${this.vinculos[0].idenCicloPessoa}`).then( res => {
                    this.$store.commit("setDadosPessoa", JSON.stringify(res.data))
                    this.carregarDados()
                })
             }
        },
        setarFlags() {
            this.dadosPessoa.dadosPessoais.flagNomeCorreto = this.checkNomeCorreto ? "S" : "N"
            this.dadosPessoa.dadosPessoais.flagDataNascCorreta = this.checkDataNascCorreta ? "S" : "N"
            this.dadosPessoa.dadosPessoais.flagDeficiencia = this.checkPossuiDeficiencia ? "S" : "N"
            this.dadosPessoa.dadosPessoais.flagNomeSocial = this.nomeSocialEscolha ? "S" : "N"
            this.dadosPessoa.dadosPessoais.flagSexo = this.dadosPessoa.dadosPessoais.sexo.code == "F" ? "F" : "M"
            if (this.dadosPessoa.dadosPessoais.nacionalidade != null && this.dadosPessoa.dadosPessoais.nacionalidade.descNacionalidade != 'BRASILEIRA' && this.dadosPessoa.dadosPessoais.nacionalidade.descNacionalidade != 'BRASILEIRA/INDIO') {
                this.dadosPessoa.dadosPessoais.flagCasadoBrasileiro = this.dadosPessoa.dadosPessoais.flagCasadoBrasileiro
            }
        },
        limparDados() {
            this.registroConjuge = getDefaultState()
        },
        async carregarDados() {
            if (this.$store.getters.getDadosPessoa) {

                this.dadosPessoa = Object.assign({}, this.$store.getters.getDadosPessoa)
                this.etapaDadosPessoais = this.$store.getters.getEtapasCiclo[0]

                var flagNomeCorreto = this.dadosPessoa.dadosPessoais.flagNomeCorreto && this.dadosPessoa.dadosPessoais.flagNomeCorreto.code ? this.dadosPessoa.dadosPessoais.flagNomeCorreto.code : this.dadosPessoa.dadosPessoais.flagNomeCorreto
                if (flagNomeCorreto == "N") {
                    //this.dadosPessoa.dadosPessoais.flagNomeCorreto = { name: "Não", code: "N" }
                    this.checkNomeCorreto = false
                } else {
                    //this.dadosPessoa.dadosPessoais.flagNomeCorreto = { name: "Sim", code: "S" }
                    this.checkNomeCorreto = true
                }
                /*if(!this.dadosPessoa.dadosPessoais.flagNomeCorreto.code){
                    if(this.dadosPessoa.dadosPessoais.flagNomeCorreto==null || this.dadosPessoa.dadosPessoais.flagNomeCorreto=="N"){
                        this.dadosPessoa.dadosPessoais.flagNomeCorreto = {name: "Não",code: "N"}
                    } else {
                        this.dadosPessoa.dadosPessoais.flagNomeCorreto = {name: "Sim",code: "S"}
                    }
                }*/

                var flagDeficiencia = this.dadosPessoa.dadosPessoais.flagDeficiencia && this.dadosPessoa.dadosPessoais.flagDeficiencia.code ? this.dadosPessoa.dadosPessoais.flagDeficiencia.code : this.dadosPessoa.dadosPessoais.flagDeficiencia;
                if (flagDeficiencia == "S") {
                    //this.dadosPessoa.dadosPessoais.flagDeficiencia = { name: "Sim", code: "S" }
                    this.checkPossuiDeficiencia = true
                } else {
                    //this.dadosPessoa.dadosPessoais.flagDeficiencia = { name: "Não", code: "N" }
                    this.checkPossuiDeficiencia = false
                }

                var flagCasadoBrasileiro = this.dadosPessoa.dadosPessoais.flagCasadoBrasileiro && this.dadosPessoa.dadosPessoais.flagCasadoBrasileiro.code ? this.dadosPessoa.dadosPessoais.flagCasadoBrasileiro.code : this.dadosPessoa.dadosPessoais.flagCasadoBrasileiro

                if (flagCasadoBrasileiro == "S") {
                    this.dadosPessoa.dadosPessoais.flagCasadoBrasileiro = 'S'
                } else {
                    this.dadosPessoa.dadosPessoais.flagCasadoBrasileiro = 'N'
                }

                /*if(!this.dadosPessoa.dadosPessoais.flagDeficiencia.code) {
                    if(this.dadosPessoa.dadosPessoais.flagDeficiencia==null || this.dadosPessoa.dadosPessoais.flagDeficiencia=="N"){
                        this.dadosPessoa.dadosPessoais.flagDeficiencia = {name: "Não",code: "N"}
                    } else {
                        this.dadosPessoa.dadosPessoais.flagDeficiencia = {name: "Sim",code: "S"}
                    }
                }*/

                var flagDataNascCorreta = this.dadosPessoa.dadosPessoais.flagDataNascCorreta && this.dadosPessoa.dadosPessoais.flagDataNascCorreta.code ? this.dadosPessoa.dadosPessoais.flagDataNascCorreta.code : this.dadosPessoa.dadosPessoais.flagDataNascCorreta;
                if (flagDataNascCorreta == "N") {
                    //this.dadosPessoa.dadosPessoais.flagDataNascCorreta = { name: "Não", code: "N" }
                    this.checkDataNascCorreta = false
                } else {
                    //this.dadosPessoa.dadosPessoais.flagDataNascCorreta = { name: "Sim", code: "S" }
                    this.checkDataNascCorreta = true
                }
                /*if(!this.dadosPessoa.dadosPessoais.flagDataNascCorreta.code){
                    if(this.dadosPessoa.dadosPessoais.flagDataNascCorreta==null || this.dadosPessoa.dadosPessoais.flagDataNascCorreta=="N"){
                        this.dadosPessoa.dadosPessoais.flagDataNascCorreta = {name: "Não",code: "N"}
                    } else {
                        this.dadosPessoa.dadosPessoais.flagDataNascCorreta = {name: "Sim",code: "S"}
                    }
                }*/

                // var flagCasadoBrasileiro = this.dadosPessoa.dadosPessoais.flagCasadoBrasileiro && this.dadosPessoa.dadosPessoais.flagCasadoBrasileiro.code? this.dadosPessoa.dadosPessoais.flagCasadoBrasileiro.code : this.dadosPessoa.dadosPessoais.flagCasadoBrasileiro
                // if(flagCasadoBrasileiro=="S"){
                //     this.dadosPessoa.dadosPessoais.flagCasadoBrasileiro = {name: "Sim",code: "S"}
                // } else {
                //     this.dadosPessoa.dadosPessoais.flagCasadoBrasileiro = {name: "Não",code: "N"}
                // }

                var flagSexo = this.dadosPessoa.dadosPessoais.flagSexo && this.dadosPessoa.dadosPessoais.flagSexo.code ? this.dadosPessoa.dadosPessoais.flagSexo.code : this.dadosPessoa.dadosPessoais.flagSexo
                //var flagDeficiencia = this.dadosPessoa.dadosPessoais.flagDeficiencia.code ? this.dadosPessoa.dadosPessoais.flagDeficiencia.code : this.dadosPessoa.dadosPessoais.flagDeficiencia
                if (flagSexo == "F") {
                    this.dadosPessoa.dadosPessoais = { ...this.dadosPessoa.dadosPessoais, sexo: { name: "Feminino", code: "F" } }
                } else if (flagSexo == "M") {
                    this.dadosPessoa.dadosPessoais = { ...this.dadosPessoa.dadosPessoais, sexo: { name: "Masculino", code: "M" } }
                }

                // Listar grupos sanguíneos    
                 this.$http.get(`${baseApiUrl}/gruposanguineos/all`).then(res => {
                    this.grupoSanguineo = res.data
                    /*codgSeap:"B+"
                    dataAtualizacao:"23/03/2020"
                    dataImportacao:"23/03/2020"
                    descGrupoSanguineo:"B+"
                    idenGrupoSanguineo:5
                    statGrupoSanguineo:1

                    */
                })

                // Listar estados civis    
                 this.$http.get(`${baseApiUrl}/estadocivils/all`).then(res => {
                    this.estadocivil = res.data
                })

                // Listar Raças-cor
                 this.$http.get(`${baseApiUrl}/tiporacacors/all`).then(res => {
                    this.cor = res.data
                })


                if (this.dadosPessoa.dadosPessoais.escolaridade == null || this.dadosPessoa.dadosPessoais.escolaridadeSeap == null) {
                    // Listar Escolaridades
                     this.$http.get(`${baseApiUrl}/escolaridades/recadastramento/all`).then(res => {
                        this.escolaridade = res.data
                    })
                } else {
                    // Listar Escolaridades a partir da escolaridade escolhida anteriormente
                     this.$http.get(`${baseApiUrl}/escolaridades/recadastramento/${this.dadosPessoa.dadosPessoais.escolaridadeSeap.idenEscolaridade}`).then(res => {
                        this.escolaridade = res.data
                    })
                }

                // Listar Tipos de Deficiência
                 this.$http.get(`${baseApiUrl}/tipodeficiencias/all`).then(res => {
                    this.deficiencia = res.data.filter(item => item.descTipoDeficiencia != "Múltipla" && item.descTipoDeficiencia != "Reabilitado");
                })

                // Listar Nacionalidades
                 this.$http.get(`${baseApiUrl}/nacionalidades/all`).then(res => {
                    this.nacionalidade = res.data
                })

                // Listar Países
                 this.$http.get(`${baseApiUrl}/paises/all`).then(res => {
                    this.paises = res.data
                })

                if (this.dadosPessoa.dadosPessoais.pais != null && this.dadosPessoa.dadosPessoais.pais.idenPais > 0) {
                    // Listar UF's
                     this.$http.get(`${baseApiUrl}/ufs/buscarPorIdenPais/${this.dadosPessoa.dadosPessoais.pais.idenPais}`).then(res => {
                        this.ufs = res.data
                    })
                }

                if (this.dadosPessoa.dadosPessoais.uf != null && this.dadosPessoa.dadosPessoais.uf.idenUf > 0) {
                    // Listar Cidades
                     this.$http.get(`${baseApiUrl}/cidades/buscarPorIdenUf/${this.dadosPessoa.dadosPessoais.uf.idenUf}`).then(res => {
                        this.cidades = res.data
                    })

                }
                // Listar parentalidades 

                 this.$http.get(`${baseApiUrl}/dadopessoalparentals/buscarPorDadoPessoal/${this.dadosPessoa.dadosPessoais.idenDadoPessoal}`).then(res => {
                    if (res.data.length > 0) {
                        this.registroConjuge = res.data[0]
                        this.registroConjuge.parentalidade.pessoaParentalidade.numrCpf = this.mascaraCpf(this.registroConjuge.parentalidade.pessoaParentalidade.numrCpf)
                    }
                })

                if (this.dadosPessoa && this.dadosPessoa.dadosPessoais.nomeSocial) {
                    this.nomeSocialEscolha = true
                }

                if (this.dadosPessoa && this.dadosPessoa.dadosPessoais.arquivosDadoPessoal.length >0) {
                     this.$http.get(`${baseApiUrl}/arquivosrecad/download/${this.dadosPessoa.dadosPessoais.arquivosDadoPessoal[0].arquivoRecad.idenArquivo}`).then(res => {
                        this.documento = res
                        this.imagemFoto = res.data
                        this.auxidFoto = this.dadosPessoa.dadosPessoais.arquivosDadoPessoal[0].idenArquivoDadoPessoal
                        this.aux = this.imagemFoto
                    })
                }
                // if (this.imagemFoto) {
                // }
                if(this.etapaDadosPessoais.statCicloPessoaFase == 'CONCLUIDO'){
                    this.isSalvo=true;
                }
            } 
        },
        filtrarUfPorIdenPais(idenPais) {
            this.$http.get(`${baseApiUrl}/ufs/buscarPorIdenPais/${idenPais}`).then(res => {
                this.ufs = res.data
                this.cidades = [];
                this.dadosPessoa.dadosPessoais.uf = null;
                this.dadosPessoa.dadosPessoais.cidade = null;
            })

        },
        filtrarCidadePorIdenUf(idenUf) {
            this.$http.get(`${baseApiUrl}/cidades/buscarPorIdenUf/${idenUf}`).then(res => {
                if (this.dadosPessoa.dadosPessoais.cidade != null && this.dadosPessoa.dadosPessoais.cidade.uf.idenUf != idenUf) {
                    this.dadosPessoa.dadosPessoais.cidade = null;
                }
                this.cidades = res.data
            })
        },
        salvarParentalidade() {
            const parentalidadeAdicionada = {
                dadoPessoal: { idenDadoPessoal: this.dadosPessoa.dadosPessoais.idenDadoPessoal },
                parentalidade: {
                    idenParentalidade: this.registroConjuge.idenParentalidade,
                    pessoa: { idenPessoa: this.dadosPessoa.pessoa.idenPessoa, numrCpf: this.dadosPessoa.pessoa.numrCpf },
                    pessoaParentalidade: {
                        idenPessoa: this.registroConjuge.parentalidade.pessoaParentalidade.idenPessoa
                        , numrCpf: this.registroConjuge.parentalidade.pessoaParentalidade.numrCpf.split(".").join("").split("-").join("")
                        , dataNascimento: this.registroConjuge.parentalidade.pessoaParentalidade.dataNascimento
                        , nomePessoa: this.registroConjuge.parentalidade.pessoaParentalidade.nomePessoa
                        , nomeMae: this.registroConjuge.parentalidade.pessoaParentalidade.nomeMae
                        , idenCiclo: this.registroConjuge.parentalidade.pessoaParentalidade.idenCiclo

                    },
                    tipoParentalidade: { idenTipoParentalidade: 5, descTipoParentalidade: "CONJUGE" }
                    , statParentalidade: 1
                },
                statDadoPessoalParental: 1
            }

            if (this.registroConjuge.idenDadoPessoalParental != "") {

                this.$http.put(`${baseApiUrl}/dadopessoalparentals/${this.registroConjuge.idenDadoPessoalParental}/${parentalidadeAdicionada.parentalidade.pessoa.idenPessoa}`, JSON.stringify(parentalidadeAdicionada))
            } else {
                this.$http.post(`${baseApiUrl}/dadopessoalparentals/${this.dadosPessoa.pessoa.idenPessoa}`, JSON.stringify(parentalidadeAdicionada))
            }
        },
        atualizarDadosPaiMae() {
            let dadosJson = {...this.dadosPessoa.pessoa}
            if (this.dadosPessoa.pessoa.numrCpfPai != null) {
                dadosJson.numrCpfPai = this.dadosPessoa.pessoa.numrCpfPai.split(".").join("").split("-").join("")
            }
            if (this.dadosPessoa.pessoa.numrCpfMae != null) {
                dadosJson.numrCpfMae = this.dadosPessoa.pessoa.numrCpfMae.split(".").join("").split("-").join("")
            }
            this.$http.post(`${baseApiUrl}/pessoasRecad/atualizarDadosPaiMae/${this.dadosPessoa.pessoa.idenPessoa}`, JSON.stringify(dadosJson))
                .then(() => {
                    //this.$toast.add({severity:'success', summary: 'Registro Adicionado com Sucesso!', life: 3000})
                })
        },
        buscarConjugePorCPF() {
            if (this.registroConjuge.parentalidade.pessoaParentalidade.numrCpf != '') {
                if (this.registroConjuge.parentalidade.pessoaParentalidade.numrCpf == this.dadosPessoa.pessoa.numrCpfMae || this.registroConjuge.parentalidade.pessoaParentalidade.numrCpf == this.dadosPessoa.pessoa.numrCpfPai || this.registroConjuge.parentalidade.pessoaParentalidade.numrCpf == this.dadosPessoa.pessoa.pessoaGeral.cpfFormatado) {
                    this.$toast.add({ severity: 'error', summary: 'O CPF do Cônjuge não pode ser igual ao CPF do Pai ou da Mãe ou do Recadastrante', life: 10000 })
                    this.registroConjuge.parentalidade.pessoaParentalidade.numrCpf = ""
                    this.registroConjuge.parentalidade.pessoaParentalidade.nomePessoa = ''
                    this.registroConjuge.parentalidade.pessoaParentalidade.dataNascimento = ''
                    this.registroConjuge.parentalidade.pessoaParentalidade.nomeMae = ''
                    this.registroConjuge.parentalidade.pessoaParentalidade.flagServidor = ''
                    this.registroConjuge.parentalidade.pessoaParentalidade.idenPessoa = ''

                } else {
                    var cpfSemMascara = this.registroConjuge.parentalidade.pessoaParentalidade.numrCpf.split(".").join("").split("-").join("")
                    this.registroConjuge.parentalidade.pessoaParentalidade.nomePessoa = ''
                    this.registroConjuge.parentalidade.pessoaParentalidade.dataNascimento = ''
                    this.registroConjuge.parentalidade.pessoaParentalidade.nomeMae = ''
                    this.registroConjuge.parentalidade.pessoaParentalidade.flagServidor = ''
                    this.registroConjuge.parentalidade.pessoaParentalidade.idenPessoa = ''
                    this.$http.get(`${baseApiUrl}/pessoasRecad/${cpfSemMascara}`).then(res => {
                        let v_data = res.data
                        this.registroConjuge.parentalidade.pessoaParentalidade = res.data
                        if (v_data.flagSexo == "F") {
                            this.registroConjuge.parentalidade.pessoaParentalidade.sexo = { name: "Feminino", code: "F" }
                        } else if (v_data.flagSexo == "M") {
                            this.registroConjuge.parentalidade.pessoaParentalidade.sexo = { name: "Masculino", code: "M" }
                        }
                    })
                }
            }
        },
        limparCamposConjuge() {
            if (this.registroConjuge.parentalidade.pessoaParentalidade.numrCpf == '') {
                this.registroConjuge.parentalidade.pessoaParentalidade.nomePessoa = ''
                this.registroConjuge.parentalidade.pessoaParentalidade.dataNascimento = ''
                this.registroConjuge.parentalidade.pessoaParentalidade.nomeMae = ''
                this.registroConjuge.parentalidade.pessoaParentalidade.flagServidor = ''
                this.registroConjuge.parentalidade.pessoaParentalidade.idenPessoa = ''
            }
        },
        validarCPF(cpf, campo = null) {

            var retorno = true;
            cpf = cpf.replace(/[^\d]+/g, '');
            let add = 0;
            let rev = 0;
            if (cpf == '') return false;
            // Elimina CPFs invalidos conhecidos	
            if (cpf.length != 11 ||
                cpf == "00000000000" ||
                cpf == "11111111111" ||
                cpf == "22222222222" ||
                cpf == "33333333333" ||
                cpf == "44444444444" ||
                cpf == "55555555555" ||
                cpf == "66666666666" ||
                cpf == "77777777777" ||
                cpf == "88888888888" ||
                cpf == "99999999999")
                retorno = false;
            // Valida 1o digito	
            for (let i = 0; i < 9; i++)
                add += parseInt(cpf.charAt(i)) * (10 - i);
            rev = 11 - (add % 11);
            if (rev == 10 || rev == 11)
                rev = 0;
            if (rev != parseInt(cpf.charAt(9)))
                retorno = false;
            // Valida 2o digito	
            add = 0;
            for (let i = 0; i < 10; i++)
                add += parseInt(cpf.charAt(i)) * (11 - i);
            rev = 11 - (add % 11);
            if (rev == 10 || rev == 11)
                rev = 0;
            if (rev != parseInt(cpf.charAt(10)))
                retorno = false;
            //return true;   

            if (!retorno) {
                this.$toast.add({ severity: 'error', summary: 'O CPF ' + this.mascaraCpf(cpf) + ' é inválido', life: 10000 })
                if (campo != null) {
                    if (campo == "cpfConjuge") {
                        this.registroConjuge.parentalidade.pessoaParentalidade.numrCpf = ''
                    } else if (campo == "cpfMae") {
                        this.dadosPessoa.pessoa.numrCpfMae = ''

                    } else if (campo == "cpfPai") {
                        this.dadosPessoa.pessoa.numrCpfPai = ''
                    }
                }
            }
        },
        verificarNomeNascimentoCorreto(valor) {
            //alert(valor)
            //let flagDataNascCorreta = this.dadosPessoa.dadosPessoais.flagDataNascCorreta.code?this.dadosPessoa.dadosPessoais.flagDataNascCorreta.code:this.dadosPessoa.dadosPessoais.flagDataNascCorreta
            //let flagNomeCorreto = this.dadosPessoa.dadosPessoais.flagNomeCorreto.code? this.dadosPessoa.dadosPessoais.flagNomeCorreto.code:this.dadosPessoa.dadosPessoais.flagNomeCorreto
            if (!valor)
                this.$toast.add({ severity: 'error', summary: 'Nome e/ou Data de Nascimento incorreto: Procure a sua Gestão de Pessoas em posse dos seus documentos pessoais para a correção', life: 10000 })

        },
        verificarCasadoBrasileiro() {
            if (this.dadosPessoa.dadosPessoais.estadoCivil &&
                this.dadosPessoa.dadosPessoais.estadoCivil.descEstadoCivil != 'CASADO(A)' &&
                this.dadosPessoa.dadosPessoais.flagCasadoBrasileiro == 'S' &&
                this.dadosPessoa.dadosPessoais.nacionalidade != null &&
                this.dadosPessoa.dadosPessoais.nacionalidade.descNacionalidade != 'BRASILEIRA' &&
                this.dadosPessoa.dadosPessoais.nacionalidade.descNacionalidade != 'BRASILEIRA/INDIO') {

                this.$toast.add({ severity: 'error', summary: 'O estado civil é incompatível com sua declaração de casado com brasileiro. Ajuste sua situação', life: 10000 })
            }
        },
        nextPage() {
            if (this.isSalvo) {
                this.$router.push({ name: 'RECADVIEW_DOCUMENTOS_PESSOAIS_VIEW' })
            } else {
                this.$emit('openDisplayModalNaoSalvou', '')
            }
        },
        limpaDeficiencia() {
            this.dadosPessoa.dadosPessoais.dadosPessoalTpDef = [];
            this.changeForm();
        },
        changeForm() {
            this.isSalvo = false
            this.$emit('changeForm', false)
        },
        changePaisNascimento() {
            this.filtrarUfPorIdenPais(this.dadosPessoa.dadosPessoais.pais.idenPais)
            this.changeForm()
        },
        changeUf() {
            this.filtrarCidadePorIdenUf(this.dadosPessoa.dadosPessoais.uf.idenUf)
            this.changeForm()
        },
        async resetImagem() {
            if (this.auxidFoto != null) {
                let response = await this.$http.delete(`${baseApiUrl}/arquivosdadopessoal/excluir/${this.auxidFoto}`)
                if (response.status == 200) {      
                    this.image = null;
                    this.aux = null;
                    this.$toast.add({ severity: 'success', summary: 'Sucesso!', detail: "A imagem foi excluída com sucesso", life: 5000 });
                    this.auxidFoto = null
                }
            } else {
                this.image = null;
                this.aux = null;
                this.$toast.add({ severity: 'success', summary: 'Sucesso!', detail: "A imagem foi excluída com sucesso", life: 5000 });
            }
        },
        onUploadFoto(e) {
            if (e.files && e.files.length > 0) {
                if (e.files[0].size > 2000000) {
                    this.$toast.add({ severity: 'error', summary: 'Erro ao enviar o arquivo', detail: "O tamanho do arquivo excede 2 MBs, por favor informe um arquivo com até 2 MBs.", life: 5000 });
                } else {
                    this.imgSrc = null
                    this.loaderTrue = true;
                    this.file = e.files[0]
                    // this.file2 = e
                    const file = e.files[0];
                    const reader = new FileReader();
                    reader.onload = event => {
                        //imagem para aparecer na tela para corte
                        this.imgSrc = event.target.result
                    };
                    reader.readAsDataURL(file);
                }
            }
        },
        resizeImage(index, file, method) {
            const reader = new FileReader()
            reader.onload = readerEvent =>{
                const img = new Image()
                //aqui começa o processo de redimensionamento da imagem
                img.onload = () => {
                    const {width, height} =
                    method === 1
                        ? this.aspectRatio(300)
                        :this.proportionalResize(img.width, img.height)
                    const canvas = document.createElement("canvas")
                    canvas.width = width
                    canvas.height = height
                    canvas.getContext("2d").drawImage(img,0,0,width,height)
                    this.images[index].content = canvas.toDataURL(
                        "image/jpeg",
                    )
                }
                img.src = readerEvent.target.result
            }
            reader.readAsDataURL(file)
          
        },
        cropImage() {
            this.cropImg = this.$refs.cropper.getCroppedCanvas().toDataURL()
            this.modalFoto = false
            this.imgSrc = ""
            var canvas = this.$refs.cropper.getCroppedCanvas()
            var ctx = canvas.getContext("2d");

            var MAX_WIDTH = 900;
            var MAX_HEIGHT = 700;

            var width = 400;
            var height = 300;

            if (width > height) {
                if (width > MAX_WIDTH) {
                    height *= MAX_WIDTH / width;
                    width = MAX_WIDTH;
                }
            } else {
                if (height > MAX_HEIGHT) {
                    width *= MAX_HEIGHT / height;
                    height = MAX_HEIGHT;
                }
            }
            if (canvas.width > MAX_WIDTH && canvas.height > MAX_HEIGHT){

                canvas.width = width;
                canvas.height = height;   
                
                ctx.drawImage(this.$refs.cropper.getCroppedCanvas(), 0, 0);

                this.$refs.cropper.getCroppedCanvas().toBlob((blob) => {
                    this.tamanhoFoto = blob;
                    const formData = new FormData()
                    formData.append('file', blob, 'name.jpeg')
                    axios.post(`${baseApiUrl}/arquivosdadopessoal/upload/${this.dadosPessoa.dadosPessoais.idenDadoPessoal}`, formData).then(res => {
                        this.aux = this.cropImg
                        this.auxidFoto = res.data.idenArquivoDadoPessoal    
                    }

                    )
    
                }, this.mime_type,0.5)
            } else {

                this.$refs.cropper.getCroppedCanvas().toBlob((blob) => {
                    this.tamanhoFoto = blob;
                    const formData = new FormData()
                    formData.append('file', blob, 'name.jpeg')
                    axios.post(`${baseApiUrl}/arquivosdadopessoal/upload/${this.dadosPessoa.dadosPessoais.idenDadoPessoal}`, formData).then(res => {
                        this.aux = this.cropImg
                        this.auxidFoto = res.data.idenArquivoDadoPessoal
    
                    }
    
                    )
    
                }, this.mime_type)
            }
        },
        AbrirModalFoto() {
            this.modalFoto = true;
        },
        limpaNome() {
            this.dadosPessoa.dadosPessoais.nomeSocial = ''
        },

    },
    mounted() {
        this.getDadosPessoa()
    }

}
</script>

<style>
/*body .p-togglebutton.p-highlight{
        background-color: #007ad9;
    border-color: #007ad9;
    color: #ffffff;
}
body .p-togglebutton {
    background-color:#f39fa2;
    border: 1px solid #f39fa2;
    color: #333333;
    -webkit-transition: background-color 0.2s, box-shadow 0.2s;
    transition: background-color 0.2s, box-shadow 0.2s;
}*/

.avisos {
    background-color: rgb(231 232 125 / 84%);
    /* Red */
    color: #000000;
    border-radius: 12px;
    padding-left: 15px;
}

.arquivoRejeitado {
    margin-top: 25px;

}

.passosSeguir {
    list-style-type: decimal-leading-zero;
    margin-left: 3vw;
    margin: 6.5px 0px 6.5px 3vw;
}

.campoFoto {
    width: 100%
}

.borderline {
    /* border-style: outset; */
    width: 70%;
    height: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    gap: 5px;
}

.imagemResponsiva {
    justify-content: center;
    align-items: center;
    max-width: 100%;
    min-width: 100%;
    border-radius: 10px;
}

.divcontainerButton {
    margin-top: 1rem;
    width: 100%;
}

.divButton {
    width: 13vw !important;
}

.p-chkbox-label {
    display: initial !important;
    padding: 4px;

}

.botaoUpload {
    padding: 100px 50px;
    width: 200px;
    color: #FFF;
    text-transform: uppercase;
    text-align: center;
    margin-top: 10px;
    cursor: pointer;
    text-decoration: none;
    width: 100%;
}

.checkBox {
    justify-content: space-between;

}

@media screen and (max-width: 40em) {
    .passosSeguir {
        margin-left: 9vw;
        text-align: justify;
    }
}

@media screen and (max-width: 40em) {
    .divButton {
        width: 30vw !important;
    }
}

@media screen and (max-width: 48em) {
    .borderline {
        width: 100%;
    }
}

@media screen and (max-width: 27em) {
    .borderline {
        width: 100%;
    }
}
</style>
<style scoped>
input[type="file"] {
    display: none;
    width: 100%;
    height: 100%;
    padding: -10px;
}

.custom-file-upload {
    border: 1px solid #ccc;
    display: inline-block;
    padding: 6px 12px;
    cursor: pointer;
}
</style>